import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Header from './components/Header';
import Footer from "./components/Footer";
import EnquiryNow from './pages/Enquiry-Now';
import Service from './pages/Service';
import HireResources from './pages/Hire-Resources';
import HireAngularJS from './pages/Hire-angular-js';
import HireFrontendDevelopers from './pages/Hire-frontend-developers';
import HireWebDevelopers from './pages/Hire-web-developers';
import HireMobileAppDeveloper from './pages/Hire-mobile-app-developer';
import HireFullStackDeveloper from './pages/Hire-full-stack-developer';
import HireCmsDeveloper from './pages/Hire-cms-developer';
import HireBackendDeveloper from './pages/Hire-backend-developer';
import HirePhpDeveloper from './pages/Hire-php-developer';
import HireUIUXDesigner from './pages/Hire-ui-ux-designer';
import HireAndroidDevelopers from './pages/Hire-android-developers';
import HireIOSDevelopers from './pages/Hire-ios-developers';
import HireNodeJsDeveloper from './pages/Hire-nodejs-developers';
import HireQADeveloper from './pages/Hire-qa-tester';
import HireReactJsDeveloper from './pages/Hire-reactjs-developers';
import HireLaravelDeveloper from './pages/Hire-laravel-developer';
import BlogList from './pages/Blog';
import BlogDetail from './pages/Blog-Detail';
import Contactus from './pages/Contact-us';
import NotFound from './pages/NotFound';

function App() {
  return (
    <>
      <Header /> 
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/about" element={<About />}></Route>
        <Route path="/enquire-now" element={<EnquiryNow />}></Route>
        <Route path="/service" element={<Service />}></Route>
        <Route path="/hire-resources" element={<HireResources />}></Route>
        <Route path="/hire-angular-js" element={<HireAngularJS />}></Route>
        <Route path="/hire-frontend-developers" element={<HireFrontendDevelopers />}></Route>
        <Route path="/hire-web-developers" element={<HireWebDevelopers />}></Route>
        <Route path="/hire-mobile-app-developers" element={<HireMobileAppDeveloper />}></Route>
        <Route path="/hire-fullstack-developers" element={<HireFullStackDeveloper />}></Route>
        <Route path="/hire-cms-developers" element={<HireCmsDeveloper />}></Route>
        <Route path="/hire-backend-developers" element={<HireBackendDeveloper />}></Route>
        <Route path="/hire-php-developers" element={<HirePhpDeveloper />}></Route>
        <Route path="/hire-ui-ux-designers" element={<HireUIUXDesigner />}></Route>
        <Route path="/hire-android-developers" element={<HireAndroidDevelopers />}></Route>
        <Route path="/hire-ios-developers" element={<HireIOSDevelopers />}></Route>
        <Route path="/hire-nodejs-developers" element={<HireNodeJsDeveloper />}></Route>
        <Route path="/hire-qa-developers" element={<HireQADeveloper />}></Route>
        <Route path="/hire-reactjs-developers" element={<HireReactJsDeveloper />}></Route>
        <Route path="/blog" element={<BlogList />}></Route>
        <Route path="/blog-detail" element={<BlogDetail />}></Route>
        <Route path="/contact-us" element={<Contactus />}></Route>
        <Route path="/hire-laravel-developers" element={<HireLaravelDeveloper />}></Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
